import { Component, OnInit, ViewEncapsulation } from '@angular/core';
declare const $: any;
import 'd3';
import '../../../assets/echart/echarts-all.js';
import { LogisticsService } from '../shared/logistics.service';

@Component({
  selector: 'app-dashboard-main',
  templateUrl: './dashboard-main.component.html',
  styleUrls: ['./dashboard-main.component.css',
  '../../../../node_modules/c3/c3.min.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [LogisticsService]
})
export class DashboardMainComponent implements OnInit {
  isAdmin:boolean;
  constructor() { }

  ngOnInit() {
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
      this.isAdmin = false;
      //console.log(localStorage.getItem("courierapp_role"));
    }
    else
    {
      this.isAdmin = true;
      //console.log(localStorage.getItem("courierapp_role"));
    }
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/dashboard-main.component.ts